// extracted by mini-css-extract-plugin
module.exports = {"list":"AlpTraitList_list__NkDcG","name":"AlpTraitList_name__2pqQy","panel":"AlpTraitList_panel__3kSxG","icon":"AlpTraitList_icon__2cg7O","compact":"AlpTraitList_compact__1QmlD"};